import mitt from "mitt";

// Singleton event emitter — leaf module with no app-internal deps so it can
// be imported from anywhere (store, services, components) without creating
// a load-time cycle through @/main.
export const emitter = mitt();
